import React from 'react';
import './SubscriptionPlan.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import { useLocation, useNavigate } from 'react-router-dom'

const SubscriptionPlan = () => {

  return (
    <div className='Subscription-container'>
      <div className='Subscription-plans'>
        <h3>BASIC</h3>
        <h4>Free</h4>
        <ul>
            <li>Up to 50 stocks can be added to the filter</li>
            <li>10 Higher and Lower stocks will be reported</li>
        </ul>
        <button type="button" class="btn btn-secondary">Upgrade</button>
      </div>
      <div className='Subscription-plans'>
        <h3>PROFESSIONAL</h3>
        <h4>Rs.1000/month</h4>
        <ul>
            <li>Up to 100 stocks can be added to the filter</li>
            <li>15 Higher and Lower stocks will be reported.</li>
        </ul>
        <button type="button" class="btn btn-primary">Upgrade</button>
      </div>
      <div className='Subscription-plans'>
        <h3>BUSINESS</h3>
        <h4>Rs.3000/month</h4>
        <ul>
            <li>Up to 200 stocks can be added to the filter</li>
            <li>30 Higher and Lower stocks will be reported.</li>
        </ul>
        <button type="button" class="btn btn-primary">Upgrade</button>
      </div>
    </div>
  )
}

export default SubscriptionPlan
